const list = [
  {
    title: "profile-menu-profile-title",
    category: "profile",
    icon: "User-profilepage",
    content: [
      {
        text: "profile-menu-profile-account",
        name: "Account",
      },
      {
        text: "profile-menu-profile-profile",
        name: "details",
      },
      {
        text: "profile-menu-profile-notifications",
        name: "account-settings",
      },
      {
        text: "account-users",
        name: "account-users",
      },
      {
        text: "profile-menu-profile-jumbocode",
        name: "Jumbocode",
      },
      {
        text: "profile-menu-profile-payments",
        name: "Payments",
      },
    ],
  },
  {
    title: "profile-menu-branding-title",
    category: "branding",
    icon: "brand",
    content: [
      {
        text: "profile-menu-branding-cover-logo",
        name: "Cover-Logo",
      },
      {
        text: "profile-menu-branding-email",
        name: "Email",
      },
      {
        text: "profile-menu-branding-bussiness-profile",
        name: "Business-Profile",
      },
    ],
  },
  {
    title: "profile-menu-jumbopay-title",
    category: "jumbopay",
    icon: "Jumbopay-profile",
    content: [
      {
        text: "profile-menu-jumbopay-account-status",
        name: "Account-Status",
      },
      {
        text: "profile-menu-jumbopay-received-payments",
        name: "Received-Payments",
      },
      {
        text: "profile-menu-jumbopay-sent-payments",
        name: "Sent-Payments",
      },
      {
        text: "profile-menu-jumbopay-payouts",
        name: "Payouts",
      },
      {
        text: "profile-menu-jumbopay-settings",
        name: "Settings",
      },
    ],
  },
  {
    title: "profile-menu-contacts-title",
    category: "contacts",
    icon: "contacts",
    content: [
      {
        text: "profile-menu-contacts-list",
        name: "Contacts-List",
      },
    ],
  },
  {
    title: "profile-menu-jumboform-title",
    category: "jumbo-forms",
    icon: "jform-black",
    content: [
      {
        text: "profile-menu-jumboform-form-management",
        name: "Form-management",
      },
      {
        text: "profile-menu-jumboform-received-orders",
        name: "received-orders",
      },
      {
        text: "profile-menu-jumboform-statuses-management",
        name: "Statuses-management",
      },
      {
        text: "profile-menu-jumboform-order-tracker",
        name: "Order-Tracker",
      },
      {
        text: "ftp-title",
        name: "ftp",
      },
      {
        text: "integration-title",
        name: "integration",
      },
      {
        text: "api-title",
        name: "api",
      },
      {
        text: "profile-menu-jumboform-activity-reports",
        name: "activity-reports",
      },
    ],
  },
];

export default list;
